<ng-template #sidenavRef>
  <vex-sidenav [collapsed]="sidenavCollapsed$ | async"></vex-sidenav>
</ng-template>

<ng-template #toolbarRef>
  <vex-toolbar  [hasShadow]="toolbarShadowEnabled$ | async" 
                [mobileQuery]="!(isDesktop$ | async)" 
                class="vex-toolbar">
  </vex-toolbar>
</ng-template>

<ng-template #footerRef>
  <vex-footer *ngIf="isFooterVisible$ | async" class="vex-footer"></vex-footer>
</ng-template>

<ng-template #quickpanelRef>
  <vex-quickpanel></vex-quickpanel>
</ng-template>

<div class="loading-bar-background-black" *ngIf="backgroundService.showLoadingBar"></div>
<div class="loading-bar-background" *ngIf="backgroundService.showLoadingBar">
  <mat-progress-spinner
    class="loading-bar"
    color="primary"
    mode="indeterminate"
    value="50">
  </mat-progress-spinner>
</div>

<vex-layout [footerRef]="footerRef" 
            [quickpanelRef]="quickpanelRef" 
            [sidenavRef]="sidenavRef" 
            [toolbarRef]="toolbarRef">
</vex-layout>